import {
    ADD_CALENDAR_SESSION,
    ADD_ROOM,
    CHANGE_SELECTED_DAY,
    DELETE_CALENDAR_SESSION,
    DELETE_CALENDAR_SESSION_BY_SESSION_ID,
    DELETE_ROOM,
    LOAD_CALENDAR,
    UPDATE_CALENDAR_SESSION,
    UPDATE_ROOM
} from "../actionTypes";

const initialState = {
    conferenceDates: [],    // List of ordered date strings as ["2019-08-10", ...]
    daySelected: 1,         // 1-based index
    calendarData: {},
    roomsById: {},
    roomIdsByDate: {},      // Object like {"2019-08-10": [roomId1, ....]}
    isCalendarLoaded: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        /* Add room to list of rooms */
        case ADD_ROOM: {
            const {room} = action.payload;
            const roomId = room.id;

            // Append room id to selected dates
            const {roomIdsByDate} = {...state};
            for (const roomDate of room.room_dates) {
                const date_str = roomDate.date_available;
                if (!roomIdsByDate.hasOwnProperty(date_str)) roomIdsByDate[date_str] = [];
                roomIdsByDate[date_str].push(roomId)
            }
            return {
                ...state,
                roomsById: {
                    ...state.roomsById,
                    [roomId]: room
                },
                roomIdsByDate
            }
        }
        /* Delete room from the state */
        case DELETE_ROOM: {
            const {roomId} = action.payload;

            /* Filter out calendar entries that are attached to the room */
            const calendarData = {};
            for (const date_str in state.calendarData) {
                calendarData[date_str] = {};

                for (const calendarId in state.calendarData[date_str]) {
                    const calendar = state.calendarData[date_str][calendarId];
                    if (calendar.room.id !== roomId) calendarData[date_str][calendar.id] = calendar;
                }
            }

            /* */
            const roomIdsByDate = {};
            for (const date_str in state.roomIdsByDate)
                roomIdsByDate[date_str] = state.roomIdsByDate[date_str].filter((rId, index) => {
                    return rId !== roomId
                });

            let {[roomId]: room, ...roomsById} = state.roomsById;

            return {
                ...state,
                calendarData,
                roomIdsByDate,
                roomsById
            }
        }
        case UPDATE_ROOM: {
            const {roomId, room} = action.payload;
            return {
                ...state,
                roomsById: {
                    ...state.roomsById,
                    [roomId]: room
                }
            }
        }
        case LOAD_CALENDAR: {
            const {conferenceDates, calendarData, roomsData} = action.payload;

            const newCalendarData = {};
            for (const date in calendarData) {
                newCalendarData[date] = {};
                for (const calendarSession of calendarData[date]) {
                    newCalendarData[date][calendarSession.id] = calendarSession;
                }
            }

            const roomsById = {};
            for (const room of roomsData.rooms) roomsById[room.id] = room;

            return {
                ...state,
                conferenceDates,
                calendarData: newCalendarData,
                roomsById,
                roomIdsByDate: roomsData.room_dates,
                isCalendarLoaded: true
            }
        }
        case CHANGE_SELECTED_DAY: {
            const {newDay} = action.payload;
            return {
                ...state,
                daySelected: newDay
            }
        }
        case ADD_CALENDAR_SESSION: {
            const {calendarSession} = action.payload;
            const {date} = calendarSession;
            return {
                ...state,
                calendarData: {
                    ...state.calendarData,
                    [date]: {
                        ...state.calendarData[date],
                        [calendarSession.id]: calendarSession
                    }
                }
            }
        }
        case UPDATE_CALENDAR_SESSION: {
            const {calendarSessionId, calendarSession} = action.payload;
            const {date} = calendarSession;
            return {
                ...state,
                calendarData: {
                    ...state.calendarData,
                    [date]: {
                        ...state.calendarData[date],
                        [calendarSessionId]: calendarSession
                    }
                }
            }
        }
        case DELETE_CALENDAR_SESSION: {
            const {calendarSessionId} = action.payload;
            const date_str = state.conferenceDates[state.daySelected - 1];

            let {[calendarSessionId]: calendarSession, ...rest} = state.calendarData[date_str];

            return {
                ...state,
                calendarData: {
                    ...state.calendarData,
                    [date_str]: rest
                }
            }
        }
        case DELETE_CALENDAR_SESSION_BY_SESSION_ID: {
            const {sessionId} = action.payload;

            /* Filter out calendar entries that are attached to the room */
            const calendarData = {};
            for (const date_str in state.calendarData) {
                calendarData[date_str] = {};

                for (const calendarId in state.calendarData[date_str]) {
                    const calendar = state.calendarData[date_str][calendarId];
                    if (calendar.session.id !== sessionId) calendarData[date_str][calendar.id] = calendar;
                }
            }

            return {
                ...state,
                calendarData
            }

        }
        default:
            return state;
    }
}
